import Vue from 'vue';

function overflowHidden(text, rows, str) {
    const style = window.getComputedStyle(text);
    const width = parseInt(style['width'], 10);
    const fontSize = parseInt(style['font-size'], 10);
    const rowCount = Math.floor(width / fontSize);
    if (str.length <= rows * rowCount) {
        text.innerText = str;
    } else {
        text.innerText = str.substring(0, rows * rowCount - 3) + '...';
    }
}

const textEllipsis = {
    inserted(el, binding) {
        const { value = '', arg } = binding;
        const { maxLines = 1 } = arg;
        // 单行直接用css控制
        if (maxLines === 1) {
            el.style.overflow = 'hidden';
            el.style.whiteSpace = 'nowrap';
            el.style.textOverflow = 'ellipsis';
            el.style.wordWrap = 'normal';
            el.innerText = value;
            return true;
        }
        overflowHidden(el, maxLines, value);
        const listenOverflow = () => {
            if (el) {
                overflowHidden(el, maxLines, value);
            }
        };
        window.addEventListener('resize', listenOverflow);
        window.addEventListener('beforeunload', () => {
            window.removeEventListener('resize', listenOverflow);
        });
        return true;
        // const width = el.parentNode.offsetWidth;
    }
};

Vue.directive('ellipsis', textEllipsis);
